import { createContext, useContext, type ReactNode } from 'react'
import { createPortal } from 'react-dom'

/**
 * Emplacement d'actions posé SUR la barre d'onglets.
 *
 * ⭐ Un écran à onglets avait deux bandeaux empilés : la barre d'onglets, puis
 * une ligne « titre + boutons ». Le titre répétait l'onglet actif, et la moitié
 * de la hauteur utile partait avant la première donnée. Les actions remontent
 * donc dans la barre d'onglets, à droite.
 *
 * ⚠️ Un portail, et non des propriétés remontées par le parent : les actions du
 * catalogue tiennent à l'état de la liste — la sélection, le nombre d'articles
 * sans code-barres, les boîtes de dialogue. Les faire vivre chez le parent
 * aurait exigé d'y hisser tout cet état, pour un simple problème de placement.
 *
 * ⚠️ Sans emplacement — page rendue hors de sa coquille à onglets — les actions
 * s'affichent SUR PLACE plutôt que de disparaître : un bouton escamoté par un
 * détail d'agencement serait pire que mal placé.
 */
export const AncreActions = createContext<HTMLElement | null>(null)

export function ActionsDOnglet({ children }: { children: ReactNode }): JSX.Element {
  const ancre = useContext(AncreActions)
  return ancre ? createPortal(children, ancre) : <>{children}</>
}
